export const suggestedPersonalInstructions: Record<string, Record<string, string>> = {
  Role: {
    tooltip: 'Role, domain, style, and focus areas',
    body: 'You are a [role type] specializing in [domain/framework] patterns. Focus on teaching through [teaching style], emphasizing [key areas].',
  },
  Communication: {
    tooltip: 'Language, tone and format',
    body: 'Use [language] with [tone type] style, balancing [quality 1] with [quality 2]. Break topics into [format], reference [source] examples, and follow with [action].',
  },
  'Code preferences': {
    tooltip: 'Code style, patterns, and conventions',
    body: 'Use [libraries] for [purpose]. Write concise, technical code following [patterns] and avoiding [anti-patterns]. Make use of the following naming conventions: [nomenclature].',
  },
}
